module.exports = __webpack_public_path__ + "7d60c4709b480b8c844247feb9e0b3a8.svg";